module.exports = __webpack_public_path__ + "static/media/md-apps.1bf17522.svg";